import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import ScheduleHeader from './components/ScheduleHeader'
import WeekView from './components/WeekView'
import DayView from './components/DayView'
import MonthView from './components/MonthView'
import useResourceData from '@/hooks/useResourceData'
import useScheduleData from '@/hooks/useScheduleData'
import Loading from '@/widgets/Loading'

function ScheduleList2() {
	const navigate = useNavigate()
	const [viewType, setViewType] = useState('Week')
	const [startDate, setStartDate] = useState(moment().startOf('isoWeek'))

  // Calculate start and end dates based on view type and current date
  const { start, end } = useMemo(() => {
		if (viewType === 'Week') {
			return {
				start: moment(startDate).startOf('isoWeek').toISOString(),
				end: moment(startDate).endOf('isoWeek').toISOString(),
			}
		} else if (viewType === 'Day') {
			return {
				start: moment(startDate).startOf('day').toISOString(),
				end: moment(startDate).endOf('day').toISOString(),
			}
		} else if (viewType === 'Month') {
			return {
				start: moment(startDate).startOf('month').toISOString(),
				end: moment(startDate).endOf('month').toISOString(),
			}
		}
		return { start: null, end: null }
	}, [viewType, startDate])

  const { data: resources, loading: resourcesLoading, error: resourcesError } = useResourceData()
	const {
		data: bookings,
		loading: bookingsLoading,
		error: bookingsError,
	} = useScheduleData(start, end)
  // console.log(`TCL -> index.jsx:17 -> ScheduleList2 -> bookings:`, bookings)


  // Navigation handlers
  const handlePrevious = () => {
		setStartDate(prevDate => {
			if (viewType === 'Week') {
				return moment(prevDate).subtract(1, 'week')
			} else if (viewType === 'Day') {
				return moment(prevDate).subtract(1, 'day')
			} else if (viewType === 'Month') {
				return moment(prevDate).subtract(1, 'month')
			}
			return prevDate
		})
  }

  const handleNext = () => {
		setStartDate(prevDate => {
			if (viewType === 'Week') {
				return moment(prevDate).add(1, 'week')
			} else if (viewType === 'Day') {
				return moment(prevDate).add(1, 'day')
			} else if (viewType === 'Month') {
				return moment(prevDate).add(1, 'month')
			}
			return prevDate
		})
  }

  const handleDateChange = newDate => {
		if (viewType === 'Week') {
			setStartDate(moment(newDate).startOf('isoWeek'))
		} else if (viewType === 'Day') {
			setStartDate(moment(newDate))
		} else if (viewType === 'Month') {
			setStartDate(moment(newDate).startOf('month'))
		}
  }

  const handleToday = () => {
		if (viewType === 'Week') {
			setStartDate(moment().startOf('isoWeek'))
		} else if (viewType === 'Day') {
			setStartDate(moment())
		} else if (viewType === 'Month') {
			setStartDate(moment().startOf('month'))
		}
  }

  const handleDayClick = dateString => {
		setViewType('Day')
		setStartDate(moment(dateString))
  }

  if (resourcesLoading || bookingsLoading) {
		return <Loading />
  }

  return (
    <>
      <div className="space-y-4">
        <ScheduleHeader 
		viewType={viewType}
		setViewType={setViewType}
		startDate={startDate}
		onPrevious={handlePrevious}
		onNext={handleNext}
		onDateChange={handleDateChange}
		onToday={handleToday}
		onAddBooking={() => navigate('/schedule/add', { state: { anchorDate: startDate.toISOString() } })}
	  />
      {viewType === 'Week' && (
        <WeekView 
          resources={resources} 
          bookings={bookings} 
          startDate={startDate}
          onDayClick={handleDayClick}
        />
      )}
      {viewType === 'Day' && (
        <DayView resources={resources} bookings={bookings} startDate={startDate} />
      )}
      {viewType === 'Month' && (
        <MonthView 
          resources={resources} 
          bookings={bookings} 
          startDate={startDate}
          onDayClick={handleDayClick}
        />
      )}
      </div>
    </>
  );
}

export default ScheduleList2;
